/**
 * Sidebar groups for the workspace settings and personal settings areas.
 * Labels, paths and icons of each page live in the section lists
 * (`WORKSPACE_SETTINGS_SECTIONS`, `SETTINGS_SECTIONS`), which the sidebar,
 * breadcrumbs and settings hubs all read. This file only decides grouping.
 */

export interface SettingsNavGroup {
  id: string;
  label: string;
  sectionIds: readonly string[];
}

export const WORKSPACE_SETTINGS_TITLE = "Workspace settings";

export const WORKSPACE_SETTINGS_NAV_GROUPS: readonly SettingsNavGroup[] = [
  {
    id: "workspace",
    label: "Workspace",
    sectionIds: ["general", "account", "members", "billing", "projects", "sso"],
  },
  {
    id: "activity",
    label: "Activity",
    sectionIds: ["api-keys", "activity"],
  },
];

export const PERSONAL_SETTINGS_TITLE = "Settings";

/**
 * Personal settings groups. The sidebar adds a "Workspace" group after
 * these, linking to the current workspace's settings when the user may
 * read them.
 */
export const PERSONAL_SETTINGS_NAV_GROUPS: readonly SettingsNavGroup[] = [
  {
    id: "account",
    label: "Account",
    sectionIds: ["profile", "notifications-list"],
  },
  {
    id: "security",
    label: "Security",
    sectionIds: ["security", "sessions", "login-history"],
  },
  {
    id: "billing",
    label: "Billing",
    sectionIds: ["billing", "referrals"],
  },
];

/** The personal settings section that carries the unread notifications badge. */
export const PERSONAL_SETTINGS_NOTIFICATIONS_SECTION_ID = "notifications-list";

export const PERSONAL_SETTINGS_WORKSPACE_GROUP_LABEL = "Workspace";

/** Workspace-level entries shown on the all-projects page. */
export const PROJECTS_HOME_NAV_LABELS = {
  allProjects: "All projects",
  newProject: "New project",
  workspaceSettings: WORKSPACE_SETTINGS_TITLE,
} as const;

/**
 * Hub pages (`/settings`, `/workspaces/:id/settings`) only highlight on an
 * exact match so they do not light up for every child page.
 */
export const SETTINGS_HUB_SECTION_ID = "general";
